module.exports = __webpack_public_path__ + "img/17852_S.cdf5fe68.png";